$(function () {
  $('.js-contact-component .callbackwish input').change(function () {
    var tel = $('.tel', $(this).closest('.js-contact-component'));
    tel.toggleClass('show');
    var callbackFrom = $('.tel-from', $(this).closest('.js-contact-component'));
    callbackFrom.toggleClass('show');
    var callbackUntil = $('.tel-until', $(this).closest('.js-contact-component'));
    callbackUntil.toggleClass('show');
    tel.find('input').prop('required', !tel.find('input').prop('required'));
  });

  $('.js-contact-component .is-customer input').change(function () {
    var accountnumber = $('.account', $(this).closest('.js-contact-component'));
    accountnumber.toggleClass('show');
    accountnumber.find('input').prop('required', !accountnumber.find('input').prop('required'));
  });

  $('.js-contact-component form').on('submit', function (e) {
    e.preventDefault();
    e.stopPropagation();
    var $this = $(this);
    var $submitButton = $this.find('[type="submit"]');
    var data = $this.serialize();
    $.ajax({
      url: $this.attr('action'),
      type: 'POST',
      data: data,
      success: function (data) {
        var forwardSummary = $submitButton.data('summaryForward');
        if (forwardSummary) {
          //Direkte Weiterleitung auf eigenständige Dankesseite
          location.href = forwardSummary;
        } else {
          $('.' + $this.closest('.js-contact-component').prop('id')).toggleClass('hide');
          $('.' + $this.closest('.contactSuccess').prop('id')).toggleClass('hide');
        }
      },
      error: function (request, error) {
        alert($('.' + $this.closest('.js-contact-component').prop('id')).attr('data-errormessage'));
      },
    });
  });
});
